<script setup>
import { ref, defineProps, watch } from 'vue';

const props = defineProps({
	dataCompleted: {
		type: Object,
		required: false,
	},
	type: {
		type: String,
		required: true,
	},
	context: {
		type: String,
		required: false,
	},
});
const studentContext = ref(props.context || '');

watch(
	() => props.context,
	(newVal) => {
		studentContext.value = newVal;
	}
);

const updateStudentContextLength = () => {
	if (studentContext.value.length > 1000) {
		studentContext.value = studentContext.value.slice(0, 1000);
	}
};
</script>
<template>
	<div class="_create-boarding _modal bg-white">
		<div
			class="_modal__content px-12 py-6 flex flex-col items-center justify-center"
		>
			<div>
				<img
					alt="Luca Education"
					src="@/assets/images/illustrations/record.png"
					title="Luca Education"
					width="250"
					height="250"
				/>
			</div>
			<div
				class="_modal__content__title text-neutral-700 font-semibold text-2xl mt-5 text-center"
			>
				{{
					props.type === 'update'
						? 'Bổ sung hồ sơ cho trẻ'
						: 'Hồ sơ của con đã có thay đổi mới'
				}}
			</div>
			<div
				class="text-center text-neutral-700 mt-2"
				v-if="props.type === 'update'"
			>
				Trợ lý Luca AI sẽ ghi nhớ để trả lời chính xác hơn trong những
				lần thảo luận tiếp theo
			</div>
			<div
				class="text-center text-neutral-700 mt-2"
				v-if="props.type === 'completed'"
			>
				Tháng này, con đã hoàn thành thêm
				{{ props.dataCompleted?.goal_count }} mục tiêu thuộc
				{{ props.dataCompleted?.skill_count }} lĩnh vực<br />
				kể từ lần tóm tắt gần nhất vào ngày
				{{ props.dataCompleted?.latest_generated_date }} <br />
				Bạn có thể tóm tắt lại hồ sơ để Luca AI hỗ trợ chính xác hơn
				trong các trao đổi tiếp theo.
			</div>
			<div
				class="mt-8 flex flex-col items-start w-full"
				v-if="props.type === 'update'"
			>
				<textarea
					v-model="studentContext"
					@input="updateStudentContextLength"
					class="w-full"
					placeholder="Ví dụ: Con nhạy cảm với tiếng ồn, dễ quá tải khi lớp đông&#10;Con hợp tác tốt khi có lịch trình rõ ràng&#10;Con không thích chạm tay, cần báo trước khi hỗ trợ"
					rows="8"
				></textarea>
				<div class="text-neutral-500 text-sm mt-1 text-right w-full">
					{{ studentContext.length }} / 1000
				</div>
			</div>
		</div>
		<div
			class="_modal__footer px-12 py-6 bg-neutral-50 flex flex-nowrap items-center"
		>
			<button
				class="button-p text-center mr-3 bg-none shadow-none text-neutral-500 hover:text-neutral-700"
				type="button"
				@click="$emit('close')"
			>
				{{ props.type === 'update' ? 'Huỷ' : 'Để sau' }}
			</button>
			<button
				v-if="props.type === 'update'"
				class="button-p text-center whitespace-nowrap"
				type="button"
				@click="$emit('submit', studentContext)"
			>
				Ghi nhớ
			</button>
			<button
				v-if="props.type === 'completed'"
				class="button-p text-center whitespace-nowrap flex items-center gap-1"
				type="button"
				@click="$emit('generate')"
			>
				<div>Tóm tắt hồ sơ</div>
				<img
					class="w-4 h-4"
					src="@/assets/images/icons/coin.png"
					alt=""
				/>
				<div>20</div>
			</button>
		</div>
	</div>
</template>

